import client from './main-client';

export const getPropertyTypesApi = (params) => client()
  .get('/options-property-types', { params });
